import { Avatar, Box, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';

const InformacionEntidadComponent = () => {
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const activo = entidadesStore.activo;

  return (
    <Paper elevation={4}>
      <Grid container spacing={0}>
        <Grid
          item
          md={12}
          align="center"
          sx={{
            position: 'relative',
          }}
        >
          <Avatar
            alt="imagen-fondo"
            variant="square"
            sx={{ width: '100%', height: 200 }}
            src={getFilesArchivos(activo.imgFondo)}
          />
          <Box
            sx={{
              backgroundColor: 'white',
              padding: 0.5,
              borderRadius: 50,
              position: 'absolute',
              top: 2,
              right: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Avatar
              alt="image-logo"
              sx={{
                width: 90,
                height: 90,
              }}
              src={getFilesArchivos(activo.imgLogo)}
            />
          </Box>
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6" fontWeight="bold">
            {activo.nombre}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Divider textAlign="left" sx={{}}>
            Detalles
          </Divider>
        </Grid>
        <Grid item md={12} sx={{ p: 2 }}>
          <Grid container spacing={0}>
            {/* <Grid item md={12}>
              <Typography variant="body">
                <strong>Correo: </strong>
                {activo.usuario.correo}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Fecha de nacimiento: </strong>
                {activo.usuario.perfil.fechaNacimiento}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Genero: </strong>
                {generosEnum[activo.usuario.perfil.genero]}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Tipo sangre: </strong>
                {getTipoSangre(activo.usuario.perfil.tipoSangre)}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Tiene internet: </strong>
                {activo.usuario.perfil.internet ? 'SI' : 'NO'}
              </Typography>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InformacionEntidadComponent;
